function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { ControlLabel, FormGroup, HelpBlock } from 'react-bootstrap';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.css';

var _DatePicker = function (_Component) {
  _inherits(_DatePicker, _Component);

  function _DatePicker() {
    var _temp, _this, _ret;

    _classCallCheck(this, _DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.get = function (key) {
      var value = _this.context.form.get(_this.props[key || 'name']);
      return Boolean(value) ? moment(value) : null;
    }, _this.text = function () {
      var date = _this.get();
      if (Boolean(date)) {
        return date.format('MM/DD/YYYY');
      }
      return '';
    }, _this.helpText = function (update) {
      var curr = update === undefined ? _this.get() : update;
      if (curr === null) {
        return null;
      }

      var text = function text(first, verb, second) {
        if (_this.props.errorText) {
          return _this.props.errorText;
        }
        return '"' + first + '" must be ' + verb + ' "' + second + '"';
      };

      var before = _this.get('before');
      if (before !== null && !curr.isBefore(before)) {
        return text(_this.props.name, 'before', _this.props.before);
      }

      var after = _this.get('after');
      if (after !== null && !curr.isAfter(after)) {
        return text(_this.props.name, 'after', _this.props.after);
      }

      return null;
    }, _this.formLabel = function () {
      var _this$props = _this.props,
          label = _this$props.label,
          required = _this$props.required;

      return label && React.createElement(
        ControlLabel,
        null,
        label,
        ' ',
        required && React.createElement(
          'span',
          { className: 'text-danger' },
          '*'
        )
      );
    }, _this.validationState = function () {
      if (_this.get() !== null) {
        return _this.helpText() === null ? 'success' : 'error';
      }
      return null;
    }, _this.validationBlock = function () {
      if (_this.get() !== null && _this.helpText() !== null) {
        return React.createElement(
          HelpBlock,
          null,
          _this.helpText()
        );
      }
      return null;
    }, _this.componentDidUpdate = function () {
      var name = _this.props.name;
      var form = _this.context.form;


      form.setError({
        message: _this.helpText(),
        name: name
      });
    }, _this.handleChange = function (value) {
      var name = _this.props.name;
      var form = _this.context.form;


      form.set(name, value);
      form.setError({
        message: _this.helpText(value),
        name: name
      });
    }, _this.render = function () {
      return React.createElement(
        FormGroup,
        { validationState: _this.validationState() },
        _this.formLabel(),
        React.createElement(DatePicker, {
          disabledKeyboardNavigation: true,
          readOnly: true,
          className: 'form-control',
          isClearable: _this.props.isClearable,
          maxDate: _this.get('max'),
          minDate: _this.get('min'),
          placeholderText: 'Click to select a date',
          selected: _this.get(),
          value: _this.text(),
          onChange: _this.handleChange
        }),
        _this.validationBlock()
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return _DatePicker;
}(Component);

_DatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  after: PropTypes.string,
  before: PropTypes.string,
  errorText: PropTypes.string,
  isClearable: PropTypes.bool,
  label: PropTypes.string,
  max: PropTypes.string,
  min: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool
} : {};

_DatePicker.contextTypes = {
  form: PropTypes.object.isRequired
};

export default _DatePicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/DatePicker.js
// module id = 676
// module chunks = 0